<div class="calendar-container">

  <div class="calendar-header">

    <button (click)="previousMonth()">‹</button>

    <h2>
  {{ getMonthName(currentMonth) }} {{ currentYear }}
</h2>

    <button (click)="nextMonth()">›</button>

  </div>

  <div class="calendar-grid header">

    <div *ngFor="let day of dayNames">
      {{ day }}
    </div>

  </div>

  <div class="calendar-grid body">

    <div *ngFor="let day of calendar" class="day-cell">

      <div *ngIf="day.date">

        <div class="date-number">
          {{ day.date }}
        </div>

        <div
          *ngFor="let event of day.events"
          class="event"
          (click)="onEventClick(event)"
        >
          {{ event.title }}
        </div>

      </div>

    </div>

  </div>

</div>